import React from 'react'
import styled from 'styled-components'

import { Button } from 'components'
import { FaAngleDoubleUp, FaAngleDoubleDown, FaPlus } from 'react-icons/fa'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.5rem 0.25rem 0.5rem;
    font-weight: bolder;
    font-size: 0.7rem;
    cursor: pointer;
    min-height: 1rem;
    background-color: var(--secondary-color);
    /* border-top: 1px solid var(--primary-accent-color); */
    /* margin-top: 0.5rem; */
    color: var(--secondary-accent-color);
    z-index:2;
    flex-shrink: 0;
`

const Icon = styled.div`
    width: 0.7rem;
    height: 0.7rem;
    font-size: 0.7rem;
    line-height: 0.7rem;
    display: flex;
    align-items:center;
    margin-left: 0.2rem;
`

const ContentContainer = styled.div`
    display: flex;
    align-items:center;
    flex-grow: 4;
`

const SideSection = props => {
    const {
        open,
        text,
        button,
        onClick,
        contextMenu
    } = props;
    const [hover, setHover] = React.useState(false)

    return (
        <Container onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <ContentContainer onClick={onClick}>
                {text}
                {hover && <Icon>{open ? <FaAngleDoubleUp/> : <FaAngleDoubleDown/>}</Icon>}
            </ContentContainer>
            
            {button ? <Button iconOnly icon={<FaPlus/>} styles={{color: 'var(--secondary-accent-color)', backgroundColor: 'var(--secondary-color)', fontSize:'0.7rem', padding: '0.2rem', margin: 0}} contextMenu={contextMenu}/> : null}          
        </Container>
    )
}

export default SideSection
